import { compose, withProps } from 'recompose';
import { withTranslation, withTranslationProvider } from '../../Common/Translations';
import { Navbar } from '../../Nav/Navbar';

const updateOrCreateFavicon = ({t}) => {
  const icon = document.querySelector('link[rel="icon"]');
  if (icon != null) {
    icon.setAttribute('href',t('navbar.favicon', ''));
  }
};

export const WithIcon = compose(
  withTranslationProvider,
  withProps(({ callbacks = [] }) => ({
    callbacks: [...callbacks, updateOrCreateFavicon]
  }))
);

export const WithFavicon = compose(
  WithIcon,
);

export default withTranslation('navbar')(Navbar);
export const undecorated = Navbar;



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithFavicon.js